import styled from 'styled-components';
import { palette } from 'styled-theme';
import { Button } from '../../../Components/uielements';

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 20px;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Input = styled.input`
  padding: 10px 12px;
  border: 1px solid ${palette('gray', 3)};
  border-radius: 4px;
  transition: border-color 0.2s;
  background-color: transparent;
  color: #fff;

  &:focus {
    outline: none;
    border-color: ${palette('border', 0)};
  }
`;

export const QuestionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  /* max-height: 435px; */
  /* overflow-y: auto; */
  padding-right: 8px;
  scroll-behavior: smooth;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const QuestionCard = styled.div`
  padding: 16px;
  border: 1px solid ${palette('gray', 3)};
  border-radius: 4px;
  background-color: transparent;
  position: relative;
`;

export const QuestionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`;

export const DeleteButton = styled.button`
  background: none;
  border: none;
  color: #ef4444;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 13px;
  transition: background-color 0.2s;
  border: 1px solid #ef4444;

  &:hover {
    border: 1px solid #fee2e2;
    background-color: #fee2e2;
  }
`;

export const QuestionRow = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
`;

export const FlexInput = styled(Input)`
  flex: 1;
`;

export const Select = styled.select`
  padding: 10px 12px;
  border: 1px solid ${palette('gray', 3)};
  border-radius: 4px;
  font-size: 14px;
  background-color: ${palette('background', 0)} !important;
  cursor: pointer;
  min-width: 120px;
  color: #fff;
  max-height: fit-content;

  &:focus {
    outline: none;
    border-color: ${palette('border', 0)};
  }
  option {
    background-color: #1e1e1e;
    color: #fff;
  }
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
`;

export const Checkbox = styled.input`
  width: 18px;
  height: 18px;
  cursor: pointer;
`;

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
  padding-left: 16px;
  border-left: 3px solid #e5e7eb;
`;

export const OptionRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const OptionInput = styled(Input)`
  flex: 1;
`;

export const AddOptionButton = styled(Button)`
  max-width: fit-content;
`;

export const RemoveOptionButton = styled.button`
  background: none;
  border: none;
  color: #ef4444;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 13px;
  transition: background-color 0.2s;
  border: 1px solid #ef4444;

  &:hover {
    border: 1px solid #fee2e2;
    background-color: #fee2e2;
  }
`;

export const AddQuestionButton = styled(Button)`
  margin-top: 16px;
  font-weight: 500;
  cursor: pointer;
`;

export const ErrorText = styled.span`
  color: #ef4444;
  font-size: 12px;
  margin-top: 4px;
`;
// view modal css

export const ViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 8px 0;
`;

export const TitleSection = styled.div`
  display: flex;
  gap: 10px;
  grid-auto-flow: column;
  padding-bottom: 12px;
`;

export const CheckListTitle = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: #fff;
  margin: 0;
`;

export const QuestionsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-height: 435px;
  overflow-y: auto;
  padding-right: 8px;
  scroll-behavior: smooth;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const QuestionItem = styled.div`
  padding: 20px;
  background-color: transparent;
  border-radius: 4px;
  border: 1px solid ${palette('gray', 3)};
  transition: all 0.2s ease;

  &:hover {
    border-color: ${palette('border', 0)};
  }
`;

export const QuestionTextWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const QuestionNumber = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const QuestionText = styled.p`
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  margin: 0;
  line-height: 1.5;
`;

export const BadgeContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-shrink: 0;
`;

export const TypeBadge = styled.span`
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  background-color: ${(props) => {
    switch (props.type) {
      case 'STRING':
        return 'rgba(123, 234, 167, 0.2)';
      case 'NUMBER':
        return 'rgba(251, 191, 36, 0.2)';
      case 'OPTION':
        return 'rgba(96, 165, 250, 0.2)';
      default:
        return 'rgba(156, 163, 175, 0.2)';
    }
  }};
  color: ${(props) => {
    switch (props.type) {
      case 'STRING':
        return '#7beaa7';
      case 'NUMBER':
        return '#fbbf24';
      case 'OPTION':
        return '#60a5fa';
      default:
        return '#9ca3af';
    }
  }};
  border: 1px solid
    ${(props) => {
      switch (props.type) {
        case 'STRING':
          return '#7beaa7';
        case 'NUMBER':
          return '#fbbf24';
        case 'OPTION':
          return '#60a5fa';
        default:
          return '#9ca3af';
      }
    }};
`;

export const RequiredBadge = styled.span`
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  background-color: rgba(239, 68, 68, 0.2);
  color: #ef4444;
  border: 1px solid #ef4444;
`;

export const OptionsTitle = styled.h4`
  font-size: 14px;
  font-weight: 600;
  color: #9ca3af;
  margin: 0 0 12px 0;
`;

export const OptionsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const OptionItem = styled.li`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #fff;
  padding: 8px 12px;
  background-color: transparent;
  border-radius: 4px;
  border: 1px solid ${palette('gray', 3)};
`;

export const OptionBullet = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #7beaa7;
  flex-shrink: 0;
`;

export const EmptyState = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
`;

export const EmptyStateText = styled.p`
  font-size: 16px;
  color: #9ca3af;
  margin: 0;
  font-weight: 500;
`;
